import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

const useGreetCategoriesStatsQuery = () => {
  return useQuery({
    queryKey: ["greet-categories-stats"],
    queryFn: () => adminApiClient.getGreetCategoriesStats(),
  });
};

export default useGreetCategoriesStatsQuery;
